import logo from './logo.svg'
import logo_dark from './logo_dark.svg'
import cross_icon from './cross_icon.svg'
import menu_icon from './menu_icon.svg'
import star_icon from './star_icon.svg'
import left_arrow from './left_arrow.svg'
import right_arrow from './right_arrow.svg'
import header_img from './header_img.png'
import brand_img from './brand_img.jpg'
import project_img_1 from './project_img_1.jpg'
import project_img_2 from './project_img_2.jpg'
import project_img_3 from './project_img_3.jpg'
import project_img_4 from './project_img_4.jpg'
import project_img_5 from './project_img_5.jpg'
import project_img_6 from './project_img_6.jpg'
import profile_img_1 from './profile_img_1.png'
import profile_img_2 from './profile_img_2.png'
import profile_img_3 from './profile_img_3.png'

export const assets = {
    logo,
    logo_dark,
    cross_icon,
    menu_icon,
    star_icon,
    header_img,
    brand_img,
    project_img_1,
    project_img_2,
    project_img_3,
    project_img_4,
    left_arrow,
    right_arrow,
}

export const projectsData = [
    {
      title: "Business Strategy & Growth Consulting",
      price: "Develop a winning business model.",
      // location: "California",
      image: project_img_1
    },
    {
      title: "Financial Planning & Budgeting",
      price: "Smart investment strategies for growth.",
      // location: "San Francisco",
      image: project_img_2
    },
    {
      title: "Marketing & Branding Solutions",
      price: "Digital marketing strategies for lead generation.",
      // location: "Chicago",
      image: project_img_3
    },
    {
      title: "Startup & Entrepreneur Coaching",
      price: "Business launch strategies.",
      // location: "Los Angeles",
      image: project_img_4
    },
    {
      title: "Operational & Process Optimization",
      price: "Streamline workflows to improve productivity.",
      // location: "San Francisco",
      image: project_img_5
    },
    {
      title: "Leadership & Team Development",
      price: "Executive coaching for business leaders.",
      // location: "Chicago",
      image: project_img_6
    },
    
  ];

  export const testimonialsData = [
    {
        name: "John Doe",
        title: "CEO of XYZ Corp",
        image: profile_img_1,
        alt: "Portrait of John Doe",
        rating: 5,
        text: "Working with NextWave Solutions has been a game changer for our company. Their strategic insights and expert guidance helped us scale our operations and significantly improve our profit margins. Highly recommended!"
    },
    {
        name: "Jane Smith",
        title: "Founder of Startup Innovations",
        image: profile_img_2,
        alt: "Portrait of Jane Smith",
        rating: 4,
        text: "The personalized approach from NextWave Solutions was exactly what our startup needed. They helped us craft a solid business model and secure key partnerships. I can't thank them enough!"
    },
    {
        name: "Alex Brown",
        title: "Director of Operations at ABC Ltd",
        image: profile_img_3,
        alt: "Portrait of Alex Brown",
        rating: 5,
        text: "NextWave Solutions The personalized approach from NextWave Solutions was exactly what our startup needed. They helped us craft a solid business model and secure key partnerships. I can't thank them enough!"
    }
];